import { useQuery } from '@tanstack/react-query';
import { CatalogPageQuerykeys } from '@enums/react-query-keys';
import { CatalogPageMetadataResponse } from '@interfaces/api/responses/catalog-page-metadata-response';

const useCatalogPageMetadataQuery = () => {
  const { data: catalogMetadata } = useQuery<CatalogPageMetadataResponse>({
    queryKey: [CatalogPageQuerykeys.GET_CATALOG_METADATA],
    staleTime: Infinity,
  });

  return {
    catalogMetadata,
  };
};

export default useCatalogPageMetadataQuery;
